import { FunctionComponent } from 'react'
import {
  Translation,
  usePlatformConfig,
  useWidgetContext,
  WidgetDisplayMode,
} from '@dxp-module/common'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import headerStyles from './header.styles'

const Header: FunctionComponent = () => {
  const styles = headerStyles()
  const {
    configuration: { displayMode },
  } = useWidgetContext()
  const {
    platformConfig: {
      myAccount: { showSignupTitle },
    },
  } = usePlatformConfig()

  return (
    <Box className={styles.root}>
      {showSignupTitle && displayMode !== WidgetDisplayMode.AUTH_SCREEN && (
        <Translation
          component="Typography"
          componentProps={{ variant: 'h3' }}
          id="trans__myaccount__create_an_account__new_customer_label"
          className={styles.formTitle}
        />
      )}
      <Box className={styles.container}>
        <Typography variant="body1" className={styles.title}>
          <Translation id="trans__myaccount__create_an_account__create_an_account" />
        </Typography>
        <Typography variant="body1" className={styles.message}>
          <Translation id="trans__myaccount__create_an_account__mandatory_label" />
        </Typography>
      </Box>
    </Box>
  )
}

export default Header
